import { render, staticRenderFns } from "./WordFile.vue?vue&type=template&id=d34b86ec&lang=pug&"
import script from "./WordFile.vue?vue&type=script&lang=ts&"
export * from "./WordFile.vue?vue&type=script&lang=ts&"
import style0 from "./WordFile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d34b86ec')) {
      api.createRecord('d34b86ec', component.options)
    } else {
      api.reload('d34b86ec', component.options)
    }
    module.hot.accept("./WordFile.vue?vue&type=template&id=d34b86ec&lang=pug&", function () {
      api.rerender('d34b86ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/icons/WordFile.vue"
export default component.exports